module.exports = __webpack_public_path__ + "static/media/grass_tile.084a7002.jpg";